module.exports = __webpack_public_path__ + "static/media/ic_download_white.4a98397c.svg";